import type { ReactNode } from 'react';

interface IListFooterProps {
  /** What the numbers in the table count, e.g. the window they cover. */
  note?: ReactNode;
  shown: number;
  total: number | null | undefined;
  onNext?: () => void;
  /** "Next 25": how many the next page brings, when the caller knows. */
  nextLabel?: string;
}

/** The line under a list: what its numbers mean, "N of M", and the next page. */
export const ListFooter = ({
  note,
  shown,
  total,
  onNext,
  nextLabel = 'Next',
}: IListFooterProps) => (
  <div className="flex items-center gap-inset">
    {note && <span className="font-mono text-micro text-faint">{note}</span>}
    <span className="ml-auto font-mono text-micro whitespace-nowrap text-faint">
      {shown.toLocaleString('en-US')}
      {typeof total === 'number' && ` of ${total.toLocaleString('en-US')}`}
    </span>
    {onNext && (
      <button
        type="button"
        onClick={onNext}
        className="rounded-control bg-chip px-flat py-1 text-meta text-primary"
      >
        {nextLabel}
      </button>
    )}
  </div>
);
